import React, { useState, useEffect } from 'react';
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';
import OnboardingVerificationForm from './OnboardingVerificationForm';
import CommonPaper from '../../common/CommonPaper';
import CommonContainer, { SIZE_GOLDEN_RATIO, SIZE_HALF } from '../../common/CommonContainer';
import { Container } from '@mui/material';
import { activateUser, fetchUserByConfirmationId } from '../../../actions/onboarding-actions';
import {
  HOME_REDIRECT_URL,
  LONG_REDIRECT_TIME,
} from '../../../utils/redirect-const';
import { ENTITY_NOT_FOUND } from '../../../utils/api-errors-const';
import CommonCenterSpinner from '../../common/CommonCenterSpinner';
import CommonCenterContainer from '../../common/CommonCenterContainer';
import { styled } from '@mui/material/styles';


const FETCH_USER_BY_CONFIRMATION_ID_ACTION = 'FETCH_USER_BY_CONFIRMATION_ID_ACTION';

const StyledContainer = styled(Container)(({ theme }) => ({
  maxWidth: 'sm',
  marginTop: theme.spacing(4),
  padding: theme.spacing(2),
  borderRadius: theme.shape.borderRadius,
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(1),
  },
}));

function OnboardingActivationPage({ apiResult, auth, user, activateUser, fetchUserByConfirmationId }) {
  const [redirect, setRedirect] = useState(false);
  const [userRole, setUserRole] = useState(undefined);
  const navigate = useNavigate();
  const { confirmationId } = useParams();
  let redirectTimer = null;

  useEffect(() => {
    fetchUserByConfirmationId(confirmationId, FETCH_USER_BY_CONFIRMATION_ID_ACTION);

    return () => {
      if (redirectTimer) {
        clearTimeout(redirectTimer);
      }
    };
  }, [fetchUserByConfirmationId, confirmationId]);

  useEffect(() => {
    if (auth?.authenticated) {
      setUserRole(auth.role);
    }
  }, [auth, apiResult]);

  if (userRole) {
    navigate(HOME_REDIRECT_URL);
  }

  if (!apiResult || !apiResult.requestResult || apiResult.requestResult.requestId !== FETCH_USER_BY_CONFIRMATION_ID_ACTION) {
    return <CommonCenterSpinner />;
  }

  return <CommonCenterContainer>{renderContent()}</CommonCenterContainer>;

  function renderContent() {
    if (apiResult.requestResult.success) {
      if (apiResult.requestResult.requestId === FETCH_USER_BY_CONFIRMATION_ID_ACTION && !redirectTimer && user) {
          return (
            <StyledContainer>
              <Typography variant="h5">Potwierdzenie rejestracji</Typography>
               To już ostatni krok, utwórz hasło ✨ <br /><br />
              <OnboardingVerificationForm
                initialValues={user}
                 onSubmit={activateUser.bind(this, confirmationId)}
              />
            </StyledContainer>
          )
      } else {
        redirectTimer = setTimeout(doRedirect, LONG_REDIRECT_TIME);
      }
    }

    return apiResult.requestResult.success ? renderActivationSuccess() : renderActivationFailure();
  }

  function renderActivationSuccess() {
    if (userRole) {
      navigate(HOME_REDIRECT_URL);
    }
    return <CommonCenterSpinner />;
  }

  function renderActivationFailure() {
    const cause = apiResult.requestResult.group;
    return (
      <CommonContainer size={SIZE_HALF}>
        <h2>Could not activate account.</h2>
        <h4>
          {cause === ENTITY_NOT_FOUND &&
            'It seems that this account has already been activated or the activation link is expired.'}
        </h4>
        <div>
          Please check the activation link or email us at{' '}
          <a href="mailto:kontakt@dietaniemowlaka.pl">kontakt@dietaniemowlaka.pl</a>.
        </div>

      </CommonContainer>
    );
  }

  function doRedirect() {
    setRedirect(true);
  }
}

OnboardingActivationPage.propTypes = {
  apiResult: PropTypes.object,
  auth: PropTypes.object,
  activateUser: PropTypes.func,
  fetchUserByConfirmationId: PropTypes.func,
};

const mapStateToProps = (store) => ({
  apiResult: store.api,
  user: store.user.profile,
  auth: store.auth,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ activateUser, fetchUserByConfirmationId }, dispatch);

export default compose(connect(mapStateToProps, mapDispatchToProps))(OnboardingActivationPage);
